/*jshint browser:true */
let selectedTheme = "dark"; // "auto", "dark" or "light"

// DOM elements
let themeSwitcher = document.getElementsByClassName("theme-switcher")[0];
const htmlDocument = document.getElementsByTagName("html")[0];

const nextDarkModeTheme = {
  "auto": "dark",
  "dark": "light",
  "light": "auto"
};

// Local Storage
const darkModeLocalStorageKey = "attila_theme"; // "dark" or "light" or null
const getLocalStorageTheme = () => {
  if (localStorage.getItem(darkModeLocalStorageKey) === null) {
    return null;
  }
  return localStorage.getItem(darkModeLocalStorageKey);
}

const updateThemeUI = (to) => {
  // "to" is one of "dark", "light", "auto"
  let destination = to;
  const useAutoDestination = destination === "auto";

  if (destination === "auto") {
    destination = getLocalStorageTheme();
    if (destination === null) {
      const isUserPrefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      destination = isUserPrefersDarkMode ? "dark" : "light";
    }
  }

  htmlDocument.querySelector('meta[name="theme-color"]').setAttribute('content', destination === "light" ? "#F5F5F4" : "#19171c");
  if (destination === "light") {
    htmlDocument.classList.remove('dark');
  } else {
    htmlDocument.classList.add('dark');
  }

  if (useAutoDestination) {
    themeSwitcher.classList.remove("moon", "light");
    themeSwitcher.classList.add("auto");
  } else if (destination === "light") {
    themeSwitcher.classList.remove("moon", "auto");
    themeSwitcher.classList.add("light");
  } else if (destination === "dark") {
    themeSwitcher.classList.remove("light", "auto");
    themeSwitcher.classList.add("moon");
  }
}

const applyNextTheme = () => {
  selectedTheme = nextDarkModeTheme[selectedTheme];

  if (selectedTheme === "auto") {
    localStorage.removeItem(darkModeLocalStorageKey)
  } else {
    localStorage.setItem(darkModeLocalStorageKey, selectedTheme)
  }

  updateThemeUI(selectedTheme)
}

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', ({ matches }) => {
  if (selectedTheme === "auto") {
    updateThemeUI(selectedTheme);
  }
})

// OnMount
const localStorageTheme = getLocalStorageTheme();
selectedTheme = localStorageTheme === null ? "auto" : localStorageTheme

setTimeout(function() {
  Array.from(themeSwitcher.getElementsByClassName("transition-none")).forEach((rayElement) => {
    rayElement.classList.replace("transition-none", "transition-all");
  })
}, 500);
updateThemeUI(selectedTheme);


themeSwitcher.addEventListener("click", () => {
  applyNextTheme()
});
